import React from 'react';
import { bool, object } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { getAgenciesDescriptionKey } from '../../../utils';
import {
    AGENCIES_BANNER_CLICK_EVENT_TYPE,
    AGENCIES_BANNER_HOVER_BANNER_EVENT_TYPE,
    AGENCIES_BANNER_HOVER_BUTTON_EVENT_TYPE, BANNER_URL_KEY_MAPPING,
    BI_CONSTS
} from '../../../constants';
import { trackClick, trackHover } from '../../../services/report';
import { trackBiEvent } from '../../../services/tracker';
import { ConfigMenuItemProps } from '../../../types';
import AgenciesBanner from '../AgenciesBanner';

const AgenciesBannerPanel = ({ eventTracker, item, isWide, isPro }) => {
    const { isMobile, userGuid, organizationId, userId } = getContext();
    const categoryId = Number(item?.reportData?.categoryId);

    const trackingData = {
        isMobile,
        userGuid,
        organizationId,
        userId,
        vertical: eventTracker.vertical,
        context: eventTracker.context,
        bucket: eventTracker.bucket,
        entry: eventTracker.entry || item?.displayName,
        path: item?.url
    };

    const onBannerClick = () => {
        trackClick(trackingData);
        trackBiEvent(
            AGENCIES_BANNER_CLICK_EVENT_TYPE,
            {
                item, actionType: BI_CONSTS.CLICK,
                trackingData,
                elementType: BI_CONSTS.CLICK,
                actionName: BI_CONSTS.CLICK
            }
        );
    };

    const onHover = (type) => {
        trackHover(trackingData);
        trackBiEvent(type, { item, actionType: BI_CONSTS.HOVER, trackingData, elementType: BI_CONSTS.HOVER });
    };

    const url = pathfinder(BANNER_URL_KEY_MAPPING[categoryId]);

    return (
        <li className="agencies-banner-item">
            <AgenciesBanner descriptionKey={getAgenciesDescriptionKey(categoryId)}
                url={url}
                isPro={isPro}
                isWide={isWide}
                onBannerHover={() => onHover(AGENCIES_BANNER_HOVER_BANNER_EVENT_TYPE)}
                onButtonHover={() => onHover(AGENCIES_BANNER_HOVER_BUTTON_EVENT_TYPE)}
                onClick={onBannerClick}/>
        </li>
    );
};

AgenciesBannerPanel.propTypes = {
    item: ConfigMenuItemProps,
    eventTracker: object,
    isWide: bool,
    isPro: bool
};

export default AgenciesBannerPanel;
